import { useDispatch, useSelector } from 'react-redux';

import { useChangeEffect, useCustomSearchParams } from 'src/hook';

import { createPaymentAddress } from 'src/thunk/payment';

import { useAppContext } from 'src/context/useAppContext';

import { selectPayment } from 'src/store/slice/payment/state';

const useOpenDeposit = () => {
  const dispatch: any = useDispatch();
  const { isDemo, paymentId } = useCustomSearchParams();

  const payment = useSelector(selectPayment);

  const { currency } = useAppContext();
  const { currency_id: selectedCurrencyId, network: selectedCurrencyNetwork } = currency;

  /**
   * useEffect for send request to create payment address if selected the currency.
   */
  useChangeEffect(() => {
    if (payment && selectedCurrencyId && !isDemo) {
      dispatch(
        createPaymentAddress({
          payment_id: paymentId,
          currency: selectedCurrencyId,
          currency_network: selectedCurrencyNetwork,
        })
      );
    }
  }, [payment, currency]);
};

export { useOpenDeposit };
